module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-42-min.986ba539.jpg";